import { isPropertyRateUpgradeRejected } from 'checkout/lib/utils/loyalty/rejectedPropertyRateUpgrades'
import type { RejectedUpgradeIdentity } from 'checkout/lib/utils/loyalty/rejectedPropertyRateUpgrades'

/**
 * Property OfferPage requires the upgrade target to exist in this room. Rejections use service IDs,
 * since availability fetches regenerate rate IDs. Search has a different missing-target policy.
 */
export function hasSellablePropertyRateUpgrade(
  room: App.RawAvailablePropertyRoomRates,
  rate: App.RawPropertyRate,
  rejectedUpgradeStay: Pick<RejectedUpgradeIdentity, 'propertyId' | 'checkIn' | 'checkOut' | 'occupancy'> | undefined,
): boolean {
  const targetRateId = rate.relations.upgradeTargets?.package
  if (!targetRateId) return false
  const target = room.rates[targetRateId]
  if (!target) return false
  if (!rejectedUpgradeStay) return true
  return !isPropertyRateUpgradeRejected({
    ...rejectedUpgradeStay,
    sourceRateId: rate.service.rateId,
    targetRateId: target.service.rateId,
  })
}
